import { HTTP } from '@/common/utils/http';
import { PaginationParams } from '@/common/utils/pagination-params';

export const CustomFormsService = {
    getCustomForms(schoolId, params) {
        const url = PaginationParams
            .createParams(params)
            .applyToUrl(`schools/${schoolId}/forms`);
        return HTTP.get(url);
    },

    getAllCustomForms(schoolId) {
        return HTTP.get(`schools/${schoolId}/forms?size=1000`);
    },

    createCustomForm(schoolId, form) {
        return HTTP.post(`schools/${schoolId}/forms`, form);
    },

    updateCustomForm(schoolId, form) {
        return HTTP.put(`schools/${schoolId}/forms`, form);
    },

    getCustomFormById(schoolId, formId) {
        return HTTP.get(`schools/${schoolId}/forms/${formId}`);
    },

    deleteCustomForms(schoolId, formIds) {
        return HTTP.delete(`schools/${schoolId}/forms?formIds=${formIds}`);
    }
};


// WEBPACK FOOTER //
// ./src/common/services/settings/custom-forms.service.js